module.exports = __webpack_public_path__ + "static/media/v8.ea5a86f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/creative-coding/v8.mp4
// module id = 6vxu
// module chunks = 0